import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductApiService {

  endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }

  getAllProduct(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/all`, { params: filters }));
  }

  searchProduct(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/search`, { params: filters }));
  }

  searchProductSet(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set/search`, { params: filters }));
  }

  updateProductSet(set_sku: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-set/update/${set_sku}`, body));
  }

  updateTiktokSet(set_sku: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/tiktok-set/update/${set_sku}`, body));
  }

  createProductSet(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product-set/create`, body));
  }

  getAllProductSet(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set/all`, { params: filters }));
  }

  getAllTiktokSet(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/tiktok-set/all`, { params: filters }));
  }

  updateMarkPriceChange(set_sku: string, mark_price_change: boolean) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-set/mark-price-change/${set_sku}/${mark_price_change}`, {}));
  }

  getSameProductSet(setSku: string) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-set/same/${setSku}`));
  }

  getSameTiktokSet(setSku: string) {
    return firstValueFrom(this.http.get(`${this.endpoint}/tiktok-set/same/${setSku}`));
  }

  searchPriceList(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/price-list/search`, { params: filters }));
  }

  createPriceList(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/price-list/create`, body));
  }

  updateProductSetCheckList(set_sku: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-set/check-list/update/${set_sku}`, body));
  }

  updateTiktokSetCheckList(set_sku: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/tiktok-set/check-list/update/${set_sku}`, body));
  }

  addNewCheckListProductSet(set_sku: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-set/check-list/add/${set_sku}`, body));
  }

  removeCheckListProductSet(set_sku: string, channel: string) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-set/check-list/remove/${set_sku}/${channel}`, {}));
  }

  addNewCheckListTiktokSet(set_sku: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/tiktok-set/check-list/add/${set_sku}`, body));
  }

  removeCheckListTiktokSet(set_sku: string, channel: string) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/tiktok-set/check-list/remove/${set_sku}/${channel}`, {}));
  }

  getAllProductPlatform(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-platform/all`, { params: filters }));
  }

  syncStockProductBySku(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product/sync-stock-by-sku`, body));
  }

  syncStockProductSetBySku(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product-set/sync-stock-by-sku`, body));
  }

  syncStockLazada(channel: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-platform/sync/stock/lazada/${channel}`, body));
  }

  syncStockShopee(channel: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product-platform/sync/stock/Shopee/${channel}`, body));
  }

  createStockPromotion(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/stock-promotion`, body));
  }

  findProductChannel(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-platform/channel`, { params: filters }));
  }

  findStockSabuysoft(body: { sku: string; branch: string }) {
    return firstValueFrom(this.http.post(`${this.endpoint}/product-platform/get/stock/sabuysoft`, body));
  }

}
